export enum SignType {
  ESignature = 'E_SIGNATURE',
  ViaTopaz = 'VIA_TOPAZ',
  InPerson = 'IN_PERSON',
  SendViaEmail = 'SEND_VIA_EMAIL',
  SendViaSMS = 'SEND_VIA_SMS',
}
